import { useCallback, useEffect, useMemo } from 'react';

import type { RelevancyCardProps } from '../../DynamicCardComponent';
import { useRelevancyFeed } from '../../model';
import { useRelevancyOptions } from '../../store';
import SandEComponent from '../SandEComponent';

import AudioService from '@services/AudioService';
import { useTranslateFn } from '@shared/Translate';
import { competitionUrl } from '@utilities/WindowContext';

const trackingData = {
  name: 'Live audio',
  category: 'sponsored card',
};

export const AudioComponent = (props: RelevancyCardProps) => {
  const { item, cardFormat } = props;
  const { toggleCardHidden } = useRelevancyFeed();
  const { options } = useRelevancyOptions();
  const t = useTranslateFn();

  const checkCardOpen = useCallback(() => {
    toggleCardHidden(item, AudioService.open);
  }, [item, toggleCardHidden]);

  useEffect(() => {
    const interval = setInterval(() => {
      checkCardOpen();
    }, 1000);

    checkCardOpen();
    return () => {
      clearInterval(interval);
    };
  }, [checkCardOpen]);

  const isWide = useMemo(() => cardFormat?.startsWith('wide'), [cardFormat]);

  return (
    <SandEComponent
      {...props}
      trackArticleId
      fetchArticle={!props?.item?.teaser}
      cardType='audioplayer'
      buttonTag='live-commentary'
      tag={`${options.competitionCode.toUpperCase()}.AUDIOSHOW.LIVE`}
      logoImg={null}
      showTitle
      title={t('radio_show')}
      hasLiveBadge
      target='_blank'
      url={`/${competitionUrl}/audioplayer/`}
      showButton={!isWide}
      trackingData={trackingData}
    />
  );
};

export default AudioComponent;
